
import Vue from 'vue';
import SectionHeading from '@/components/general/utils/SectionHeading.vue';

export default Vue.extend({
	name: 'BookingSteps',

	components: { SectionHeading },

	data() {
		return {};
	},

	computed: {
		isMobile(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		},
		steps() {
			return [
				{
					number: 1,
					text: this.$t('cust.booking_steps.step_one_title'),
					smallText: this.$t('cust.booking_steps.step_one_subtitle')
				},
				{
					number: 2,
					text: this.$t('cust.booking_steps.step_two_title'),
					smallText: this.$t('cust.booking_steps.step_two_subtitle')
				},
				{
					number: 3,
					text: this.$t('cust.booking_steps.step_three_title'),
					smallText: this.$t('cust.booking_steps.step_three_subtitle')
				},
				{
					lastNumber: 4,
					text: this.$t('cust.booking_steps.step_four_title'),
					smallText: this.$t('cust.booking_steps.step_four_subtitle')
				}
			];
		}
	}
});
